import '@styles/styles.css'
import 'typeface-raleway'

import React from 'react'
import { MinScreenProvider } from '@context/minScreen'
import { FullPageProvider } from '@context/fullPageContext'

import Cookie from '@components/Cookie'

const Wrapper = ({ element }) => {
  return (
    <>
      <FullPageProvider>
        <MinScreenProvider screens={{
          sm: '640px',
          md: '768px',
          lg: '1024px',
          xl: '1280px',
          '2xl': '1536px',
        }}>
          {element}
          <Cookie />
        </MinScreenProvider>
      </FullPageProvider>
    </>
  )
}

export const wrapRootElement = ({ element }) => {
  return <Wrapper element={element}></Wrapper>
}
